<template>
	<section class="pass-details">
    <div class="pass-details--wrapper">
      <div class="pass-details--container">
        <div class="pass-details--image">
          <img src="@/assets/images/banner/informacao-extra.png" alt="">
        </div>
        <div class="pass-details--text">
          <h3>empiricus pass empresas</h3>
          <h2>Mais do que um benefício</h2>
          <p>
            Agora, pela primeira vez, pensamos em um projeto inédito voltado para empresas e gestores,
            que querem oferecer a oportunidade de crescimento financeiro por meio de investimentos aos colaboradores.
          </p>
          <p>
            Que enxergam a importância da educação financeira e como pessoas prósperas financeiramente
            podem contribuir ainda mais com a sua empresa.
          </p>
          <v-btn class="pass-details--cta-btn" @click="goToForm">
            <span>Fale com a gente</span>
            <i class="mdi mdi-chevron-right button"></i>
          </v-btn>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  methods: {
    goToForm () {
      const form = document.getElementById('contact')
      form.scrollIntoView({ behavior: 'smooth' })
    },
  }
}
</script>

<style lang="scss">
.pass-details {
  background-color: var(--neutral-black-faq);
  display: flex;
  justify-content: center;
  width: 100%;
}
.pass-details--wrapper {
  display: flex;
  justify-content: center;
  max-width: 1920px;
  width: 100%;
}
.pass-details--container {
  max-width: 1256px;
  padding: 40px 16px;
  width: 100%;

  @media only screen and (min-width: 600px) {
    align-items: center;
    display: flex;
    padding: 80px 32px;
  }

  @media only screen and (min-width: 1024px) {
    padding: 80px 16px;
  }
}

.pass-details--image {
  margin-bottom: 20px;

  @media only screen and (min-width: 600px) {
    margin: 0;
    max-width: 50%;
    width: 100%;
  }

  img {
    height: auto;
    max-width: 585px;
    width: 100%;
  }
}

.pass-details--text {
  @media only screen and (min-width: 600px) {
    margin: 0;
    max-width: 50%;
    width: 100%;
  }

  h3 {
    color: var(--red);
    font-family: var(--dm-sans-bold);
    font-size: 1.1875rem;
    line-height: 22px;
    margin-bottom: 20px;
    text-transform: uppercase;

    @media only screen and (min-width: 600px) {
      font-size: 1.0625rem;
      line-height: 24px;
      margin-bottom: 10px;
    }

    @media only screen and (min-width: 1024px) {
      font-size: 1.25rem;
      line-height: 27px;
    }

    @media only screen and (min-width: 1440px) {
      font-size: 1.625rem;
      line-height: 29px;
      margin-bottom: 20px;
    }
  }

  h2 {
    color: var(--white);
    font-size: 1.5rem;
    font-family: var(--dm-sans-regular);
    line-height: 26px;
    margin-bottom: 20px;

    @media only screen and (min-width: 600px) {
      font-size: 1.6875rem;
      line-height: 31px;
      margin-bottom: 10px;
      max-width: 297px;
    }

    @media only screen and (min-width: 1024px) {
      font-size: 1.9375rem;
      line-height: 35px;
      max-width: 428px;
    }

    @media only screen and (min-width: 1440px) {
      font-size: 2.75rem;
      line-height: 50px;
      margin-bottom: 20px;
      max-width: 500px;
    }
  }

  p {
    color: var(--light-grey);
    font-size: .9375rem;
    font-family: var(--dm-sans-regular);
    line-height: 23px;
    margin-bottom: 20px !important;

    @media only screen and (min-width: 600px) {
      font-size: .875rem;
      line-height: 21px;
      max-width: 297px;
    }

    @media only screen and (min-width: 1024px) {
      font-size: 1rem;
      line-height: 24px;
      max-width: 428px;
    }

    @media only screen and (min-width: 1440px) {
      font-size: 1.25rem;
      line-height: 30px;
      margin-bottom: 40px !important;
      max-width: 500px;
    }
  }

  .pass-details--cta-btn {
    background-color: var(--red) !important;
    color: var(--white) !important;
    font-family: var(--dm-sans-regular);
    font-size: .875rem;
    height: 44px !important;
    font-weight: 400;
    text-transform: unset !important;
    width: 100%;

    @media only screen and (min-width: 600px) {
      max-width: 176px;
    }

    @media only screen and (min-width: 1024px) {
      font-size: 1rem;
      height: 48px !important;
      max-width: 196px;
    }

    @media only screen and (min-width: 1440px) {
      font-size: 1.125rem;
      height: 56px !important;
      max-width: 224px;
    }

    i {
      margin-top: 4px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Section/Section3.vue